import axios from 'axios';
export function getAutocompleteSuggestions(config, apiUrl, queryParams, callback, handleError) {
  axios.get(apiUrl + "/address-api/autocomplete?" + queryParams, config).then(callback)["catch"](handleError);
}
export function requestAddressVerification(config, apiUrl, queryParams, callback, handleError) {
  axios.get(apiUrl + "/address-api/verify?" + queryParams, config).then(callback)["catch"](handleError);
}